module.exports = __webpack_public_path__ + "assets/checkmark.2f7c578b.svg";